import last from 'lodash/last';
import size from 'lodash/size';
import templateUrl from './dynamic-menus.html';

export const dynamicMenusComponent = {
    bindings: {
        menuDetails: '<',
        slugUrl: '<'
    },

    templateUrl,

    controller: class DynamicMenusComponent {
        constructor($state, BreadcrumbService, DynamicMenusService) {
            'ngInject';

            this.$state = $state;
            this.dynamicMenusService = DynamicMenusService;
            this.breadcrumbService = BreadcrumbService;
        }

        $onInit() {
            this._checkIsPageAvailable();
            this.breadcrumb = this.menuDetails.data.breadcrumb;
            this.parentState = this.dynamicMenusService.getParentStateObject();
            this.parentName = this.parentState ? this.parentState.name : '';
            this.activeMenu = this._getActiveMenuName();
        }

        isContentHaveEditorDetails() {
            switch (this.activeMenu) {
                //GetThere Program
                case 'CallCenter':
                case 'ConnectionToCare':
                case 'VoucherProgram':
                case 'TravelTrainingGetting':
                case 'GettingThere':
                case 'NewsRuralMobilityProject':
                case 'PlanningAndTechnicalAssistance':
                case 'TransportationLinks':
                case 'GrantApplications':
                case 'Industry':
                case 'TelemedicineDeliveryProgramAssistance':
                case 'Page1':
                case 'Page2':
                case 'Page3':
                case 'Page4':
                case 'Page5':
                    return true;
                default:
                    return false;
            }
        }

        isNewReportMenu() {
            if(this.parentName === 'PublicationsAndDocuments') {
                return (this.activeMenu !== 'GetthereCallCenterStatistics' && this.activeMenu !== 'ThereConferenceMaterials' && this.activeMenu !== 'Milepost' && this.activeMenu !== 'MilepostArchive' && this.activeMenu !== 'ProgressReports' && this.activeMenu !== 'ProgressReportsArchive') ? true : false;
            }
            return false;
        }

        _getActiveMenuName() {
            return this.breadcrumb ? last(this.breadcrumb).name : 'Home';
        }

        _checkIsPageAvailable() {
            if (size(this.menuDetails.data) === 0) {
                const pageNotFoundPageBreadcrumb = this._getPageNotFoundPageBreadcrumb();
                this.breadcrumbService.setPageBreadcrumbs(pageNotFoundPageBreadcrumb);
                this.$state.go('PageNotFound');
            }
        }

        _getPageNotFoundPageBreadcrumb() {
            return this.dynamicMenusService.getPageNotFoundPageBreadcrumb();
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/components/dynamic-menus/dynamic-menus.component.js